import { Lease, LeaseStatus, LeaseStatusType } from '../../types/lease'
import {
    SET_LEASE_LIST,
    SET_LEASE_LOADING,
    SET_LEASE_ERROR,
    LeaseActionTypes,
    SET_SELECTED_LEASE,
    SET_SELECTED_STATUS,
} from './types'
import { ThunkAction } from 'redux-thunk'
import { RootState } from '..'
import { axiosInstance } from '../../helpers/axios'

export const setLeaseList = (leaseList: Lease[] | null): LeaseActionTypes => ({
    type: SET_LEASE_LIST,
    leaseList,
})

export const setLeaseLoading = (loading: boolean): LeaseActionTypes => ({
    type: SET_LEASE_LOADING,
    loading,
})

export const setLeaseError = (error: string | null): LeaseActionTypes => ({
    type: SET_LEASE_ERROR,
    error,
})

export const setSelectedLease = (
    selectedLease?: Lease | null,
): LeaseActionTypes => ({
    type: SET_SELECTED_LEASE,
    selectedLease,
})

export const setSelectedStatus = (
    selectedStatus: LeaseStatusType | null,
): LeaseActionTypes => ({
    type: SET_SELECTED_STATUS,
    selectedStatus,
})

export const fetchLeases = (): ThunkAction<
    Promise<void>,
    RootState,
    unknown,
    LeaseActionTypes
> => {
    return async (dispatch, getState) => {
        try {
            dispatch(setLeaseLoading(true))
            const response = await axiosInstance.get('lease/lease-tenant/', {
                params: {
                    occupiable: true,
                    root_lease: true,
                },
            })
            const leases: Lease[] = Array.isArray(response.data)
                ? response.data
                : []
            const apartmentId = getState().user.leasingContext?.apartment?.id
            const filtered = apartmentId
                ? leases.filter(
                      (lease) =>
                          String(lease.apartment_id) === String(apartmentId),
                  )
                : leases
            const preferredLeaseId =
                getState().user.leasingContext?.active_lease_id
            dispatch(setLeaseList(filtered))
            dispatch(initializeSelectedLease(filtered, preferredLeaseId))
        } catch (error) {
            dispatch(
                setLeaseError(
                    error instanceof Error
                        ? error.message
                        : 'An error occurred',
                ),
            )
        } finally {
            dispatch(setLeaseLoading(false))
        }
    }
}

export const initializeSelectedLease = (
    leaseList: Lease[],
    preferredLeaseId?: string | number | null,
): ThunkAction<void, RootState, unknown, LeaseActionTypes> => {
    return (dispatch) => {
        if (preferredLeaseId != null) {
            const preferred = leaseList.find(
                (lease) => String(lease.id) === String(preferredLeaseId),
            )
            if (preferred) {
                dispatch(setSelectedLease(preferred))
                return
            }
        }
        if (leaseList.length > 0) {
            const currentLease = leaseList.find(
                (lease) => lease.status === LeaseStatus.CURRENT,
            )
            if (currentLease) {
                dispatch(setSelectedLease(currentLease))
                return
            }
            const noticeLease = leaseList.find(
                (lease) => lease.status === LeaseStatus.NOTICE,
            )
            if (noticeLease) {
                dispatch(setSelectedLease(noticeLease))
                return
            }
            const sortedLeases = [...leaseList].sort(
                (a, b) =>
                    new Date(b.start_date).getTime() -
                    new Date(a.start_date).getTime(),
            )
            dispatch(setSelectedLease(sortedLeases[0]))
        } else {
            dispatch(setSelectedLease(null))
        }
    }
}
